<div class="mt-2 mb-2">
  <mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState()" (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header class="borderBottom">
        <mat-panel-title><span class="title">Condizione Giuridica e Vincoli</span></mat-panel-title>
        <mat-panel-description class="justify-content-end">
          @if (!saved) {
<i class="bi bi-exclamation-circle-fill" style="color: red; font-size: large;"></i>
}
          @if (saved) {
<i class="bi bi-check-circle-fill" style="color: green; font-size: large;"></i>
}
        </mat-panel-description>

      </mat-expansion-panel-header>

      <div class="container-fluid p-1 p-lg-2">
        <form [formGroup]="legalForm">
          <div class="row justify-content-start align-items-center">
            <div class="col-12 mt-2 text-center">
              <span class="subTitle">Acquisizione</span>
            </div>

            <div class="col-12 col-md-6 mt-3">
              <label for="acquisitionType" class="form-label" style="font-weight: bold;">
                Tipo Acquisizione
              </label>
              <select class="form-select" aria-label="Default select example" formControlName="acquisitionType"
                id="acquisitionType"
                [class.is-invalid]="legalForm.get('acquisitionType')?.invalid && (legalForm.get('acquisitionType')?.dirty || submitted)">
                <option [ngValue]="null" disabled>Non specificato</option>
                @for (option of listAcquisitionType; track option) {
<option [ngValue]="option.id" class="form-control">
                  {{option.definition}}
                </option>
}
              </select>
            </div>

            <div class="col-12 col-md-6 mt-3">
              <label for="name" class="form-label" style="font-weight: bold;">
                Nome
              </label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Titolo della scheda" id="name"
                  formControlName="name"
                  [class.is-invalid]="legalForm.get('name')?.invalid && (legalForm.get('name')?.dirty || submitted)">
              </div>
              @if (legalForm.get('name')?.invalid && legalForm.get('name')?.dirty) {
<div>
                <span style="font-size: x-small; color: red;">Max 50 caratteri</span>
              </div>
}
            </div>

            <div class="col-12 col-md-6 mt-3">
              <label for="acquisitionDate" class="form-label" style="font-weight: bold;">
                Data Acquisizione
              </label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Titolo della scheda" id="acquisitionDate"
                  formControlName="acquisitionDate"
                  [class.is-invalid]="legalForm.get('acquisitionDate')?.invalid && (legalForm.get('acquisitionDate')?.dirty || submitted)">
              </div>
              @if (legalForm.get('acquisitionDate')?.invalid && legalForm.get('acquisitionDate')?.dirty) {
<div>
                <span style="font-size: x-small; color: red;">Max 25 caratteri</span>
              </div>
}
            </div>

            <div class="col-12 col-md-6 mt-3">
              <label for="acquisitionLocation" class="form-label" style="font-weight: bold;">
                Luogo Acquisizione
              </label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Titolo della scheda" id="acquisitionLocation"
                  formControlName="acquisitionLocation"
                  [class.is-invalid]="legalForm.get('acquisitionLocation')?.invalid && (legalForm.get('acquisitionLocation')?.dirty || submitted)">
              </div>
              @if (legalForm.get('acquisitionLocation')?.invalid && legalForm.get('acquisitionLocation')?.dirty) {
<div>
                <span style="font-size: x-small; color: red;">Max 50 caratteri</span>
              </div>
}
            </div>
          </div>
          <div class="row justify-content-start align-items-center mt-4">
            <div class="col-12 mt-2 text-center">
              <span class="subTitle">Condizione Giuridica</span>
            </div>
          </div>
          <div class="row justify-content-start">
            <div class="col-12 col-md-6 mt-3">
              <label for="generic_indication" class="form-label" style="font-weight: bold;">
                Indicazione generica<sup>*</sup>
              </label>
              <select class="form-select" aria-label="Default select example" formControlName="generic_indication"
                id="generic_indication"
                [class.is-invalid]="legalForm.get('generic_indication')?.invalid && (legalForm.get('generic_indication')?.dirty || submitted)">
                <option [ngValue]="null" disabled>Non specificato</option>
                @for (option of listGenericIndication; track option) {
<option [ngValue]="option.id" class="form-control">
                  {{option.definition}}
                </option>
}
              </select>
            </div>
          </div>
          <div class="row justify-content-start">
            <div formArrayName="specific_indication" class="col-12 col-md-6 mt-2">
              <div class="col-12 col-md-4">
                <label class="form-label" style="font-weight: bold;">
                  Indicazioni specifiche
                  <sup>*</sup>
                </label>
              </div>
              @for (reason of getSpecificIndicationControls().controls; track reason; let datesIndex = $index) {
<div
                [formGroupName]="datesIndex" class="row mt-1">

                <div class="col-12 col-md-6 input-group">
                  <input type="text" class="form-control" id="date-{{datesIndex}}" formControlName="indication"
                    [class.is-invalid]="reason.invalid && (submitted || reason.dirty)">
                  @if (datesIndex != 0) {
<button type="button" class="btn btn-danger"
                    (click)="removeSpecificIndication(datesIndex)"
                    [disabled]="getSpecificIndicationControls().length === 1">
                    <i class="bi bi-trash"></i>
                  </button>
}
                </div>
                @if (reason.errors?.['maxlength'] && reason.dirty) {
<div>
                  <span style="font-size: x-small; color: red;">Max 250 caratteri</span>
                </div>
}
              </div>
}
              <button class="btn btn-outline-dark mt-2" type="button" (click)="addSpecificIndication()">
                <span class="me-2">Aggiungi Indicazioni specifiche</span>
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>
        </form>

        <div class="row justify-content-center mt-4 borderTop">
          @if (legalForm.invalid && submitted) {
<div class="col-12 mt-2 text-center">
            <small>Compilare correttamente tutti i campi obbligatori per abilitare il
              salvataggio
            </small>
          </div>
}
          <div class="col-12 col-md-6 col-lg-4 mt-1 text-center">
            <button class="btn btn-outline-dark" (click)="save()">Salva</button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
